import {IOccasions} from "../../../../../../server/src/base/entities/occasion/IOccasions";
import {Occasion} from "../../../../../../server/src/base/entities/occasion/Occasion";
import {Sorting} from "./Sorting";
import {OccasionsDecorator} from "../../../../../../server/src/base/entities/occasion/OccasionsDecorator";

export class OccasionsSorting extends OccasionsDecorator{

    private sortedOccasions:Array<Occasion>;

    private pricingSorting:Sorting;
    private mileageSorting:Sorting;

    constructor(occasions:IOccasions){
        super(occasions);
        this.pricingSorting = Sorting.None;
        this.mileageSorting = Sorting.None;

        this.occasions.Updated().subscribe(() => {this.Update()});
        this.Update();
    }

    public Value(): Array<Occasion> {
        return this.sortedOccasions;
    }

    public SetPricingSorting(sorting:Sorting){
        this.pricingSorting = sorting;
        if(this.pricingSorting != Sorting.None){
            this.mileageSorting = Sorting.None;
        }
        this.Update();
    }

    public SetMileageSorting(sorting:Sorting){
        this.mileageSorting = sorting;
        if(this.mileageSorting != Sorting.None){
            this.pricingSorting = Sorting.None;
        }
        this.Update();
    }

    public MileageSorting(): Sorting{
        return this.mileageSorting;
    }
    public PriceSorting(): Sorting{
        return this.pricingSorting;
    }

    private Update(){
        let occasions = this.occasions.Value().slice();
        this.UpdatePricingSorting(occasions);
        this.UpdateMileageSorting(occasions);

        this.sortedOccasions = occasions;
        this.updated.dispatch();
    }

    private UpdatePricingSorting(occasions:Array<Occasion>){
        if(this.pricingSorting == Sorting.None){
            return;
        }
        occasions.sort((occasion1,occasion2) => {
            if(this.pricingSorting == Sorting.Ascending){
                return occasion1.price - occasion2.price;
            }else{
                return occasion2.price - occasion1.price;
            }
        });
    }

    private UpdateMileageSorting(occasions:Array<Occasion>){
        if(this.mileageSorting == Sorting.None){
            return;
        }
        occasions.sort((occasion1,occasion2) => {
            if(this.mileageSorting == Sorting.Ascending){
                return occasion1.mileage - occasion2.mileage;
            }else{
                return occasion2.mileage - occasion1.mileage;
            }
        });
    }
}


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/domain/occasions/sorting/OccasionsSorting.ts